import { WhatsappToUserConstants } from "../constants/whatsapptouser.constants";

const WhatsappToUserReducer = (state, action) => {
  switch (action.type) {
    case WhatsappToUserConstants.FETCH_WHATSAPPTOUSER_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case WhatsappToUserConstants.FETCH_WHATSAPPTOUSER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        whatsappToUsers: action.payload.data,
        paging: action.payload.paging,
      };
    case WhatsappToUserConstants.FETCH_WHATSAPPTOUSER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case WhatsappToUserConstants.ADD_WHATSAPPTOUSER_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case WhatsappToUserConstants.ADD_WHATSAPPTOUSER_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case WhatsappToUserConstants.ADD_WHATSAPPTOUSER_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
      };

    case WhatsappToUserConstants.DOWNLOAD_WHATSAPPTOUSER_REQUEST:
      return {
        ...state,
        isLoadingDownload: true,
        downloadFileType: action.payload.fileType,
      };
    case WhatsappToUserConstants.DOWNLOAD_WHATSAPPTOUSER_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case WhatsappToUserConstants.DOWNLOAD_WHATSAPPTOUSER_FAILURE:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
        hasError: true,
      };

    default:
      return state;
  }
};

export default WhatsappToUserReducer;
